// todo npt-13160: move this lib outside of shared
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { SearchCriterion, SearchQuery } from '@neptune/search-query-domain';

import { KnownAttributes } from 'domain/experiment/attribute';

export function buildSearchLeaderboardMetaQuery(
  isArchived = false,
  selectedExperimentNames?: string[],
  selectedRunIds?: string[],
): SearchQuery {
  const criteria: Array<SearchQuery | SearchCriterion> = [
    {
      attribute: KnownAttributes.Archived,
      operator: '=',
      type: 'bool',
      value: isArchived,
    },
  ];

  if (selectedRunIds && selectedRunIds.length > 0) {
    const itemsCriteria: SearchCriterion[] = selectedRunIds.map((value: string) => ({
      attribute: KnownAttributes.Id,
      operator: '=',
      type: 'string',
      value,
    }));

    const itemsQuery: SearchQuery = {
      operator: 'or',
      criteria: itemsCriteria,
    };
    criteria.push(itemsQuery);
  }

  if (selectedExperimentNames && selectedExperimentNames.length > 0) {
    const itemsCriteria: SearchCriterion[] = selectedExperimentNames.map((value: string) => ({
      attribute: KnownAttributes.Name,
      operator: '=',
      type: 'string',
      value,
    }));

    const itemsQuery: SearchQuery = {
      operator: 'or',
      criteria: itemsCriteria,
    };
    criteria.push(itemsQuery);
  }

  return {
    operator: 'and',
    criteria,
  };
}
